import { Fragment, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Transition } from '@headlessui/react';
import { FadeLoader } from "react-spinners";
import GrayButton from './GrayButton';
import GreenButton from './GreenButton';
import { useState } from 'react';

const ConfirmReleaseModal = (props) => {
    const { t } = useTranslation();
    const { isShown, setShown, handleModal, fiatAmount, isLoading, method, email, name, id } = props;
    const [active, setActiveButton] = useState(false);
    const cancelButtonRef = useRef(null)

    const handleCheck = (e) => {
        setActiveButton(e.target.checked);
    }

    return (
        <Transition.Root show={isShown} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setShown}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-first-theme text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="bg-first-theme px-4 pt-5 pb-4 sm:p-6 sm:pb-4 text-white relative">
                                    <div className='text-center green-font text-3xl mb-8'>
                                    {t("Confirm to Release Crypto")}
                                    </div>
                                    <div className='text-second-theme text-center mb-8'>
                                    {t("Do not release crypto unless you have receive confirmation of payment")}
                                    </div>
                                    <div className='p-4 bg-black rounded-lg mb-8'>
                                        <div className='flex justify-between mb-2'>
                                            <span className='text-second-theme'>Seller's {method} Email</span>
                                            <span>{email}</span>
                                        </div>
                                        <div className='flex justify-between mb-2'>
                                            <span className='text-second-theme'>{t("Account Name")}</span>
                                            <span>{name}</span>
                                        </div>
                                        <div className='flex justify-between mb-2'>
                                            <span className='text-second-theme'>{t("Amount")}</span>
                                            <span>$ {fiatAmount}</span>
                                        </div>
                                        <div className='flex justify-between'>
                                            <span className='text-second-theme'>{t("Reference Message")}</span>
                                            <span className='w-1/2 break-words text-right'>{id}</span>
                                        </div>
                                    </div>
                                    <div className=''>
                                        <label className="flex items-start mb-4">
                                            <input type="checkbox" onChange={handleCheck}  className="green-font w-8 h-8 green-checkbox border border-gray-300 rounded" />
                                            <span htmlFor="default-checkbox" className="pl-2 text-second-theme">{t("I confirm that I have received the exact fund from the buyer as listed above")}</span>
                                        </label>
                                    </div>
                                    <div className='flex justify-between'>
                                        <GrayButton cssClass="w-5/12" title={t("Cancel")} size="lg" onClick={() => setShown(false)} />
                                        <GreenButton cssClass="w-5/12" title={t("Confirm")} size="lg" onClick={handleModal} active={active} />
                                    </div>
                                    {
                                        isLoading && 
                                            <div className='w-full h-full z-50 absolute top-0 left-0 flex items-center justify-center bg-opacity-40 bg-gray-400'>
                                                <FadeLoader loading color='white' />
                                            </div>
                                    }
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default ConfirmReleaseModal;